var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 89,
    viewBox: "0 0 82 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9449_141481)",
    filter: "url(#filter0_d_9449_141481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6963 31.0889C14.2634 26.6296 16.7824 22.5644 20.0759 19.1796C23.3694 15.7949 27.3572 13.173 31.7586 11.4986C43.5445 7.28686 54.9641 10.2445 59.1158 22.2195C63.1136 33.7491 50.1461 41.6339 51.8661 46.9452L53.5584 51.8435L37.1897 57.6332L34.6542 50.57C31.8112 42.4041 44.272 32.8097 42.5993 27.9201C41.4248 24.5477 37.7027 24.9743 34.5952 26.0739C30.7892 27.4299 27.3998 32.813 25.6166 37.422L12.6963 31.0889ZM47.0795 61.1394C53.3511 58.9183 59.1157 61.7533 60.9317 66.8478C62.7477 71.9423 60.0346 77.4362 53.515 79.689C51.0081 80.6665 48.2273 80.6332 45.7553 79.5959C43.2834 78.5586 41.312 76.5979 40.2543 74.1246C39.8559 72.8263 39.7164 71.4604 39.8439 70.105C39.9713 68.7495 40.3632 67.4312 40.997 66.2252C41.6309 65.0193 42.4943 63.9494 43.538 63.0768C44.5817 62.2041 45.7851 61.5458 47.0795 61.1394Z",
    fill: "#E52C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9449_141481",
    x: -3.84375,
    y: 0.89209,
    width: 89.687,
    height: 91.2156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9449_141481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9449_141481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9449_141481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61,
    fill: "white",
    transform: "translate(0.15625 59.4133) rotate(-66.1198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.ed805d60cdde8ffe4454932090de6ad8.svg";
export { ForwardRef as ReactComponent };